export { AuthSync, syncAuthTrackingIdentity } from './providers/clerk/client/auth-sync'
export { type AuthDomainEnv, isSatelliteHost } from './providers/clerk/client/domain'
export {
  buildPrimaryAuthUrl,
  getPrimaryAuthOrigin,
} from './providers/clerk/client/primary-auth'
export { UserButton } from './providers/clerk/client/provider'
export { SignInModal } from './providers/clerk/client/sign-in-modal.client'
export { SignUpModal } from './providers/clerk/client/sign-up-modal.client'
